import dynamic from 'next/dynamic'

export const DynamicFilterCatalogSkeleton = dynamic(() =>
	import('./FilterCatalogSkeleton').then(({ FilterCatalogSkeleton }) => FilterCatalogSkeleton)
)
